module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 21.946 21.946",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#pdf",
      toString: function () {
        return this.url;
      }
    }